<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-account-cash</v-icon>{{$t('qualitycheck.customer.customers')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <CustomerForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import CustomerForm from '../../components/customer/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'Customer';

const { mapFields } = createHelpers({
  getterType: 'customer/getField',
  mutationType: 'customer/updateField'
});

export default {
  name: 'CustomerCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    CustomerForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('customer', ['create', 'reset'])
  }
};
</script>
